import * as React from "react";
import { createContext, useContext } from "react";
const PrescriptionFormInputContext = createContext(null);
PrescriptionFormInputContext.displayName = "PrescriptionFormInputContext";
const usePrescriptionFormInput = () => {
  const context = useContext(PrescriptionFormInputContext);
  if (context === null) {
    throw new Error("No PrescriptionFormInputContext available.");
  }
  return context;
};
const PrescriptionFormInputProvider = ({
  children,
  ...props
}) => {
  const value = React.useMemo(() => {
    const { parentId, name } = props;
    const idPrefix = `${parentId}-${name}`;
    return {
      ...props,
      idPrefix,
      selectId: `${idPrefix}-select`,
      labelId: `${idPrefix}-label`,
      selectName: `prescription-select-${name}`
    };
  }, [props]);
  return /* @__PURE__ */ React.createElement(PrescriptionFormInputContext.Provider, { value }, children);
};
export {
  PrescriptionFormInputContext,
  PrescriptionFormInputProvider,
  usePrescriptionFormInput
};
//# sourceMappingURL=PrescriptionFormInputContext.js.map
